import { render, staticRenderFns } from "./addCodeChain.vue?vue&type=template&id=a0492724&scoped=true"
import script from "./addCodeChain.vue?vue&type=script&lang=js"
export * from "./addCodeChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0492724",
  null
  
)

export default component.exports